import { useAtomValue } from "jotai/index";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import RedoSvg from "@/icons/Redo.svg?react";
import UndoSvg from "@/icons/Undo.svg?react";
import { startVoteActiveTabAtom, startVoteVisibilityAtom } from "@/interface/AppStore";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";
import { HStack } from "@/shared/ui/Stack";
import styles from "./BottomLeftBar.module.scss";

export const BottomLeftBar = () => {
    const { t } = useTranslation();
    const actionSymbol = canv.actionManager.actionSymbol;

    const isStartVoteVisible = useAtomValue(startVoteVisibilityAtom);
    const startVoteActiveTab = useAtomValue(startVoteActiveTabAtom);
    const isLeftBarVisible = isStartVoteVisible && startVoteActiveTab === "new";

    if (isLeftBarVisible) return null;

    return (
        <div className={styles.bottomLeftBar}>
            {!canv.isBoardModeView() && (
                <HStack gap={2} className={styles.toolBoxArrows}>
                    <Tooltip
                        content={t("bottomBar.undo")}
                        hotkey={`${actionSymbol} + Z`}
                        placement="right"
                    >
                        <BottomBarItem onClick={canv.eventManager.Undo.bind(canv.eventManager)}>
                            <UndoSvg />
                        </BottomBarItem>
                    </Tooltip>
                    <Tooltip
                        content={t("bottomBar.redo")}
                        hotkey={`${actionSymbol} + Shift + Z`}
                        placement="right"
                    >
                        <BottomBarItem onClick={canv.eventManager.Redo.bind(canv.eventManager)}>
                            <RedoSvg />
                        </BottomBarItem>
                    </Tooltip>
                </HStack>
            )}
        </div>
    );
};
